module.exports = __webpack_public_path__ + "static/media/do1.bf60effa.png";